// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".banner .container[data-v-3378bab0]{display:block}.banner .container h2[data-v-3378bab0]{color:#fff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
